document.addEventListener('DOMContentLoaded', function() {
  const toggles = document.querySelectorAll('.new-toggle-answer');
  
  toggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      // Find the closest parent .new-faq-tab and then locate the .new-faq-answer within it
      const faqTab = this.closest('.new-faq-tab');
      const answer = faqTab.querySelector('.new-faq-answer');
      const isExpanded = this.getAttribute('aria-expanded') === 'true';

      this.setAttribute('aria-expanded', !isExpanded);
      answer.setAttribute('aria-hidden', isExpanded);

      if (isExpanded) {
        answer.style.maxHeight = '0';
        answer.style.opacity = '0';
      } else {
        answer.style.maxHeight = '500px'; // Adjust as needed
        answer.style.opacity = '1';
      }

      this.textContent = isExpanded ? '+' : '−';
    });
  });
});
